import { Routes, Route, Navigate } from 'react-router-dom';
import { Shell } from './components/Shell';
import { AoisList } from './routes/AoisList';
import { AoiDetail } from './routes/AoiDetail';
import { PoolOrdersList } from './routes/PoolOrdersList';
import { PoolOrderDetail } from './routes/PoolOrderDetail';
import { Brief } from './routes/Brief';
import { Inbox } from './routes/Inbox';
import { PartyDetail } from './routes/PartyDetail';
import { DocumentDetail } from './routes/DocumentDetail';
import { LeadList, WyLeadList } from './routes/LeadList';
import { WyAoisList }   from './routes/WyAoisList';
import { WyAoiDetail }  from './routes/WyAoiDetail';
import { WyOrdersList } from './routes/WyOrdersList';
import { WyOrderDetail } from './routes/WyOrderDetail';
import { Search } from './routes/Search';

// Subroutes are all relative to /mi (mounted by main.tsx).
export function MiApp() {
  return (
    <Shell>
      <Routes>
        <Route index                       element={<Navigate to="aois" replace />} />
        {/* Weld — unchanged */}
        <Route path="aois"                 element={<AoisList />} />
        <Route path="aoi/:id"              element={<AoiDetail />} />
        <Route path="brief"                element={<Brief />} />
        <Route path="pool-orders"          element={<PoolOrdersList />} />
        <Route path="pool-orders/:id"      element={<PoolOrderDetail />} />
        <Route path="inbox"                element={<Inbox />} />
        <Route path="leads"                element={<LeadList />} />
        <Route path="party/:id"            element={<PartyDetail />} />
        <Route path="document/:doc_number" element={<DocumentDetail />} />
        <Route path="search"               element={<Search />} />
        {/* Wyoming — new, additive. Same SPA shell, dedicated routes. */}
        <Route path="wy/aois"              element={<WyAoisList />} />
        <Route path="wy/aoi/:id"           element={<WyAoiDetail />} />
        <Route path="wy/orders"            element={<WyOrdersList />} />
        <Route path="wy/orders/:id"        element={<WyOrderDetail />} />
        <Route path="wy/leads"             element={<WyLeadList />} />
        <Route path="*"                    element={<Navigate to="aois" replace />} />
      </Routes>
    </Shell>
  );
}
